import * as React from "react";
const SvgScrollUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 20, viewBox: "0 0 14 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 7L1.41 8.41L6 3.83V20H8V3.83L12.59 8.42L14 7L7 0L0 7Z", fill: "currentColor" }));
export default SvgScrollUp;
